import React from 'react';

export const AICopyPerformancePage: React.FC = () => {
  const stats = {
    totalGenerated: 247,
    applied: 89,
    avgScore: 87.3,
    topPerformer: '+23% CTR vs manual'
  };

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-3xl font-bold">🤖 AI Copy Performance</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm">Total Generated</p>
              <p className="text-3xl font-bold mt-2">{stats.totalGenerated}</p>
            </div>
            <span className="text-4xl">✨</span>
          </div>
        </div>

        <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm">Applied to Campaigns</p>
              <p className="text-3xl font-bold mt-2">{stats.applied}</p>
            </div>
            <span className="text-4xl">📈</span>
          </div>
        </div>

        <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm">Avg Quality Score</p>
              <p className="text-3xl font-bold mt-2">{stats.avgScore}</p>
            </div>
            <span className="text-4xl">📊</span>
          </div>
        </div>

        <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm">Best Result</p>
              <p className="text-lg font-bold mt-2">{stats.topPerformer}</p>
            </div>
            <span className="text-4xl">🏆</span>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
        <h3 className="font-semibold text-lg mb-4">Performance Trends</h3>
        <div className="h-64 flex items-center justify-center border-2 border-dashed border-stroke rounded-lg">
          <p className="text-gray-500">📊 Chart: AI Copy Performance Over Time</p>
        </div>
      </div>

      <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
        <h3 className="font-semibold text-lg mb-4">🏆 Top Performing AI Copy</h3>
        <div className="space-y-3">
          {[
            { headline: 'Limited Time: 40% Off Everything', ctr: '+45%', score: 96 },
            { headline: 'Transform Your Life Today', ctr: '+38%', score: 93 },
            { headline: 'Join 10K+ Happy Customers', ctr: '+32%', score: 89 }
          ].map((copy, index) => (
            <div key={index} className="p-4 border border-stroke rounded-lg">
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-medium">{copy.headline}</p>
                  <p className="text-sm text-gray-500">CTR Improvement: {copy.ctr}</p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200 rounded-full text-sm font-medium">
                  Score: {copy.score}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
